// extracted by mini-css-extract-plugin
module.exports = {"page1":"Page1_page1__1o4-D","bg":"Page1_bg__3mo-J","text":"Page1_text__3Wc2Y","bg2":"Page1_bg2__1eeXl","imgContent":"Page1_imgContent__tCUsr"};